module.exports = __webpack_public_path__ + "static/media/bg-den.cf188168.png";